import _ from 'lodash';
import { createRouter, createWebHashHistory } from 'vue-router';
import DefaultLayout from 'src/layouts/DefaultLayout.vue';
import Home from 'view/home.vue';
import Login from 'view/Login.vue';
import OrdersList from 'view/Orders/List.vue';
import auth from 'app-core/auth';
import config from 'app-core/config'; 

const router = createRouter({
	history: createWebHashHistory(),
	routes: [
		{
			path: '/login',
			name: 'login',
			component: Login,
			meta: { layout: DefaultLayout }
		},
		{
			path: '/home',
			name: 'home',
			component: Home,
			meta: { requiresAuth: true, layout: DefaultLayout }
		},

		{
			path: '/browse/:companyId',
			name: 'browse',
			component: Home,
			meta: { requiresAuth: true, layout: DefaultLayout },
			props: (route) => _.merge(route.params, route.query)
		},
		{
					
			path: '/site/:siteId',
			name: 'site',
			component: Home,
			meta: { requiresAuth: true, layout: DefaultLayout },
			props: (route) => _.merge(route.params, route.query)
		},

		{
					
			path: '/site/:siteId/orders/list',
			name: 'orders-list',
			component: OrdersList,
			meta: { requiresAuth: true, layout: DefaultLayout },
			props: (route) => _.merge(route.params, route.query)
		},

		{
			path: '/site/:siteId/orders/detail/:orderId?',
			name: 'orders-detail',
			component: () => import('view/Orders/Detail.vue'), // lazy-load the detail component
			meta: { requiresAuth: true, layout: DefaultLayout },
			props: (route) => _.merge(route.params, route.query)
		},

		{
			path: '/',
			redirect: '/login'
		},
		{
			path: '/recovery',
			redirect: '/login'
		},
		{
			path: '/:pathMatch(.*)*',
			redirect: '/login'
		}
	]
});

router.beforeEach(async (to, from, next) => {
	if (__DEBUG__)
		console.debug('Router before each', { to, from, next });

	// change page title from meta
	// Config.getVueApp()
	const appTitle = 'Voice POS';
	const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
	// document.title = appTitle + (nearestWithTitle ? ': ' + nearestWithTitle.meta.title : '');
	document.title = nearestWithTitle ? nearestWithTitle.meta.title : appTitle;

	if (to.matched.some(r => r.meta && r.meta.requiresAuth)) {
		try {
			await auth.ensureAuth();
			next();
		} catch (ex) {
			console.error('Authentication failed', ex);
			next({ path: '/login', query: { redirect: to.fullPath } });
		}
	} else {
		next();
	}
});

export default router;
